<template>
  <div class="column height-100" :class="{'is-6': !detail, 'is-12 is-paddingless': detail}">
    <div class="card height-100">
      <header class="header-card">
        <p> {{ $t('societes.regleFacturation.title') }} </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field
              :label="$t('societes.regleFacturation.title')"
              :custom-class="detail ? 'has-text-weight-normal is-italic is-marginless' : ''">
              <b-select
                v-if="!detail"
                v-model="societe.regleFacturationId"
                expanded>
                <option
                  v-for="regle in reglesFacturation"
                  :key="regle.id"
                  :value="regle.id">
                  {{ getLabelRegleFacturation(regle) }}
                </option>
              </b-select>
              <router-link-blank
                v-else-if="regleFacturationSociete"
                :message="regleFacturationSociete.label"
                :to="regleFacturationSociete.to"
                :class="{'text-access-no-permission':
                  !checkPermissions(perms.regleFacturation.lecture)}"
                class="lien">
              </router-link-blank>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { REGLE_FACTURATION } from '@/configuration/presse/permissionsPresseConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'gestionRegleFacturation',
  components: {
    routerLinkBlank,
  },
  props: {
    societe: {
      required: true,
      type: Object,
    },
    detail: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      perms: {
        regleFacturation: REGLE_FACTURATION,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    reglesFacturation() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(r => r.societeId === this.societe.id);
    },
    regleFacturationSociete() {
      if (!this.societe.regleFacturationId) return null;
      const find = this.reglesFacturation
        .find(el => el.id === this.societe.regleFacturationId);
      if (!find) return null;
      return {
        to: {
          name: 'c.presse.regle_facturation-detail',
          params: { id: find.id },
        },
        label: this.getLabelRegleFacturation(find),
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLabelRegleFacturation(regle) {
      if (!regle) return null;
      return [regle.code, regle.libelle].join(' - ');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.regleFacturation,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
